import { ChainName } from '@src/configs/chainInfo'
import { LiquiditySource, ResultCode } from '@src/enums'

export type IOrder = {
    sentDate: string
    pair: string
    buy: string
    sell: string
    quantity: number
    paired: boolean
    price: number
    chain: string
}

export interface IQuoteParams {
    walletAddress: string
    srcChain: ChainName
    dstChain: ChainName
    srcAssetAddress: string
    dstAssetAddress: string
    srcAmount: bigint
    targetAddress: string
}

export enum OrderStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    EXPIRED = 'expired',
}

export interface IOrderData {
    src_contract_address: string
    src_wallet_address: string
    dst_wallet_address: string
    src_filler_address?: string
    filler_address?: string
    target_address?: string
    fillerAddress?: string
    targetAddress?: string
    order_direction: {
        // Original V1 format properties
        src_token_address: string
        dst_token_address: string
        dst_lzc: number
    }
    order_funding: {
        // Original V1 format properties
        src_amount_in: string
        dst_amount_out: string
        bond_fee: number
        bond_token_address: string
        bond_amount: string
    }
    order_expiration: {
        timestamp: number
        challengeOffset: number
        challengeWindow: number
    }
}

export interface IQuoteData {
    bond_amount: bigint
    bond_asset_address: string
    bond_fee: number
    challenge_offset: number
    challenge_window: number
    created_at: string
    dst_amount: bigint
    dst_asset_address: string
    dst_chain: string
    expired: boolean
    expires_at: string
    id: number
    invalid_amount: boolean
    liquidity_source: LiquiditySource
    src_amount: bigint
    src_asset_address: string
    src_chain: string
    wallet_address: string
    order_data: IOrderData
    reject_order: boolean
}

export interface IQuoteResponse {
    status: ResultCode
    errorMsg?: string
    quote: IQuoteData | null
}

export interface IOrderDirectionParameter {
    srcAsset: string
    dstAsset: string
    dstLzc: number
}

export interface IOrderFundingParameter {
    srcQuantity: bigint
    dstQuantity: bigint
    bondFee: number
    bondAsset: string
    bondAmount: bigint
}

export interface IOrderExpirationParameter {
    timestamp: number
    challengeOffset: number
    challengeWindow: number
}

export interface IOrderHistoryItem {
    id: string
    taker_address: string
    maker_address: string | null
    src_asset_address: string
    dst_asset_address: string
    src_chain: string
    dst_chain: string
    src_amount: number | string
    dst_amount: number | string
    created_at: string
    filled_at: string | null
    expires_at: string
    completed: boolean
    place_tx: string
    fill_tx: string | null
    eta: number
    order_type: 'default' | 'cctp'
}
